<template>
  <div class="dialog-container dialog-light review-import">
    <div class="Unsuccessful-import-dialog">
      <div class="dialog-header">
        <ax-dialog-header text="Unsuccessful import" :type="'unsuccessful-import'" class="pt-0"></ax-dialog-header>
      </div>
      <div class="dialog-body pb-0">
        <div class="row">
          <div class="col-12 text-center">
            <p class="m-0">The following rows were marked as failed in the import, please reupload the file once you have fixed  each issue.</p>
          </div>
        </div>
        <div class="mt-5 mb-0">
          <div class="card bg-white rounded-1">
            <div class="card-body">
              <div class="border-table">
                <div class="row header-row">
                  <div class="col-2">
                    <label class="font-weight-bold">Row</label>
                  </div>
                  <div class="col-4">
                    <label class="font-weight-bold">Name</label>
                  </div>
                  <div class="col-6">
                    <label class="font-weight-bold">Error</label>
                  </div>
                </div>
                <div class="row align-items-center data-row" v-for="error in errorData" :key="error.row">
                  <div class="col-2">
                    {{ error.row }}
                  </div>
                  <div class="col-4">
                    {{ error.name }}
                  </div>
                  <div class="col-6">
                    <span class="text-danger">{{ error.status.message }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-lg-5 text-center">
            <k-button
              class="btn btn-lg btn-secondary w-100 save mb-2"
              type="submit"
              @click="$emit('reupload')"
            >Reupload</k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default({
  name: "unsuccessful-import-excel",
  props: {
    errorData: Array
  }
})
</script>
